// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-border[data-v-718eef66]{border:2px solid #333!important;max-width:420px}", ""]);
// Exports
module.exports = exports;
